/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { useState, Fragment, useEffect } from 'react';
import {
  Label,
  Input,
  Card,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Badge,
} from 'reactstrap';
import ExternalSourcesForm from './externalSourcesForm';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
} from '../../../../../helpers/AxiosAPI';
import {
  API_External_Source,
  gAPI_Users_By_Id,
  API_Sync_SABRE,
} from '../../../../../constants/APIs';
import moment from 'moment';
import Validation from '../../../../../components/Validation';
import {
  faTrashAlt,
  faEdit,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntlMessages from '../../../../../helpers/IntlMessages';
function generateRandomColor() {
  var arr = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  return arr[Math.floor(Math.random() * arr.length)];
}

const ExternalSourcesList = ({
  email,
  externalSourceList,
  tags,
  LoadData,
  sabreIntegration,
  locale,
  propertyId,
}) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [comments, setComemnts] = useState('');
  const [sourceDetails, setSourceDetails] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tagsColor, setTagsColor] = useState([]);

  useEffect(() => {
    if (tags !== undefined && tags.length > 0) {
      let lst = [];
      tags.map((m, index) => {
        lst.push({
          label: m,
          color: generateRandomColor(index),
        });
      });
      setTagsColor(lst);
    }
  }, [externalSourceList]);

  const handleDeleteToggle = () => {
    setIsDelete(!isDelete);
  };

  const handleEditToggle = () => {
    setIsEdit(!isEdit);
  };

  const handleEditClick = (details) => {
    setSourceDetails(details);
    handleEditToggle();
  };

  const handleDeleteClick = (details) => {
    setSourceDetails(details);
    handleDeleteToggle();
    setComemnts('');
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      let body = {
        id: sourceDetails.id,
        modifiedBy: res.data.fullName,
        comments: comments,
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_External_Source}/${sourceDetails.id}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          handleDeleteToggle();
          LoadData();
        }
      });
    });
  };

  const handleSyncManualy = (item) => {
    if (item.sourceType === 'WebPage') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        AxiosAPI({
          method: 'put',
          url: `${API_External_Source}/${item.id}`,
          data: {
            userName: res.data.fullName,
            isManual: true,
            email: email,
          },
        }).then((res) => {
          if (
            res.data.HttpStatusCode !== undefined &&
            res.data.HttpStatusCode === 400 &&
            res.data.Messages !== undefined &&
            res.data.Messages !== null &&
            res.data.Messages.length > 0
          ) {
            setMsg(res.data.Messages);
            setOpen(true);
          } else {
            NotificationManager.success(
              '',
              'We have received your request. It will take few minutes.',
              3000,
              null,
              null,
              'success'
            );
            LoadData();
          }
        });
      });
    } else handleSabre(item);
  };

  const handleUpdate = (item, primary) => {
    if (primary !== undefined) {
      if (primary) item.sourceStatus = 'Active';
      else item.sourceStatus = 'Inactive';
    }
    item.modifiedBy = 'Admin';
    AxiosAPI({
      method: 'put',
      url: `${API_External_Source}/${item.id}`,
      data: item,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        LoadData();
        if (isEdit === true) handleEditToggle();
      }
    });
  };

  const handleSabre = (item) => {
    AxiosAPI({
      method: 'get',
      url: `${API_External_Source}/${item?.id}`,
    })
      .then((res) => {
        console.log(item);
        const upload = {
          groupId: getGroupID(),
          propertyId: propertyId,
          integrationId: sabreIntegration?.id,
          guestRooms: res.data?.synXisConfiguration?.guestRooms,
          languageCode: locale,
          contactInfo: res.data?.synXisConfiguration?.contactInfo,
          locationInfo: res.data?.synXisConfiguration?.locationInfo,
          policies: res.data?.synXisConfiguration?.policies,
          propertyDescription:
            res.data?.synXisConfiguration?.propertyDescription,
        };
        AxiosAPI({
          method: 'post',
          url: `${API_Sync_SABRE}`,
          data: upload,
        }).then((res) => {
          NotificationManager.success(
            '',
            'The Import process has been initiated. Check Details in about 15 minutes.',
            3000,
            null,
            null,
            'success'
          );
          setTimeout(() => {
            // window.location.reload();
          }, 1000);
        });
      })
      .catch((err) => console.log('err', err));
  };

  return (
    <>
      <Card className="d-flex flex-row mx-2" style={{ borderRadius: '10px 10px 0px 0px', backgroundColor: 'var(--theme-color-2)' }}>
        <div className="d-flex flex-grow-1 min-width-zero">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row text-white" style={{ marginTop: '4px' }}>
            <p className="mb-1 ml-4 text-small font-weight-bold w-40 w-sm-100">Web Page Section</p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">Last Modified</p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">Last Synced</p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">Sync Schedule</p>
            <p className="mb-1 text-small font-weight-bold w-10 w-sm-100 text-center">Status</p>
            <p className="mb-1 text-small font-weight-bold w-20 w-sm-100"></p>
            <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">Actions</p>
          </div>
        </div>
      </Card>
      {externalSourceList !== undefined &&
        externalSourceList.length > 0 &&
        externalSourceList.map((item) => (
          <Card
            className="d-flex flex-row mx-2"
            style={{ borderRadius: '0px' }}
          >
            <div className="mt-1 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center my-0">
                <p className="ml-4 text-small w-40 w-sm-100">
                  <b>{item?.name}</b>
                  <p className="">({item.id})</p>
                </p>

                {/* <p className="mb-1 text-muted text-small w-20 w-sm-100">                  
                  {item?.tags.length > 0 &&
                    item.tags.map((m, i) => (
                      <Badge
                        color={
                          tagsColor.length > 0 &&
                          tagsColor.filter((f) => f.label === m)[0].color
                        }
                        className="mt-1 mr-1"
                      >
                        {m}
                      </Badge>
                    ))}
                </p> */}
                <p className="text-muted text-small w-20 w-sm-100">
                  {moment(item.createdUtc).format('MMM DD, YYYY hh:mm')}
                </p>
                <p className="text-muted text-small w-20 w-sm-100">
                  {moment(item.lastRun).format('YYYY') === '0001' ? '' : moment(item.lastRun).format('MMM DD, YYYY hh:mm')}
                </p>
                <p className="text-muted text-small w-20 w-sm-100 pl-4">
                  {item.frequency}
                </p>
                <p className="text-muted text-small w-10 w-sm-100 text-center">
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small"
                    checked={item.sourceStatus === 'Active' ? true : false}
                    onChange={(primary) => handleUpdate(item, primary)}
                  />
                </p>
                {/* <div className=" w-15 w-sm-100 text-center">
                  <Button
                    color="secondary"
                    size="xs"
                    outline
                    onClick={() => handleDownload(item)}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>{' '}
                    Download
                  </Button>
                </div> */}
                <div className=" w-20 w-sm-100 text-center">
                  <Button
                    color="primary"
                    outline
                    size="xs"
                    onClick={() => handleSyncManualy(item)}
                  >
                    Sync Now
                  </Button>
                </div>
                <div className="w-10 w-sm-100">
                  <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={() => handleEditClick(item)}
                  />
                  <Fragment>
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={() => handleDeleteClick(item)}
                    />
                  </Fragment>
                </div>
              </div>
            </div>
          </Card>
        ))}
      {isEdit && sourceDetails !== undefined && (
        <ExternalSourcesForm
          taglist={tags}
          label={'Update Source'}
          sabreIntegration={sabreIntegration}
          sourceDetails={sourceDetails}
          toggle={handleEditToggle}
          submit={handleUpdate}
          visible={isEdit}
        ></ExternalSourcesForm>
      )}

      {isDelete && sourceDetails !== undefined && (
        <Modal
          isOpen={isDelete}
          toggle={handleDeleteToggle}
          style={{ maxWidth: '600px' }}
        >
          <ModalHeader toggle={handleDeleteToggle}>
            <IntlMessages id="dashboards.deleteDocument" />
          </ModalHeader>
          <ModalBody>
            <h6 className="mb-3">
              <IntlMessages id="dashboards.confirmDelete" />
            </h6>

            {/* <div className="mb-3">
              <Label>Comments</Label>
              <Input
                type="text"
                name="comments"
                value={comments}
                onChange={(e) => {
                  setComemnts(e.target.value);
                }}
              />
            </div> */}
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDelete}>
              <IntlMessages id="dashboards.delete" />
            </Button>
            <Button color="secondary" onClick={handleDeleteToggle}>
              Back
            </Button>
          </ModalFooter>
        </Modal>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(ExternalSourcesList));
